import { lightColorPalette } from '@linearb/linui-common';
import { Select } from '@material-ui/core';
import type { SelectProps } from '@material-ui/core';
import { createShouldForwardProp } from 'common/utils/style.utils';
import styled from 'styled-components';

interface StyledSelectProps extends SelectProps {
  disabledMode?: boolean;
}

export const StyledSelect = styled(Select).withConfig({
  shouldForwardProp: createShouldForwardProp(['disabledMode'])
})<StyledSelectProps>`
  ${({ disabledMode }) =>
    disabledMode &&
    `
    border-radius: 4px;
    background-color: ${lightColorPalette.lbBlue_5};

    > div > div > p {
      color: ${lightColorPalette.lbGreyDisabled}!important;
    }

    .MuiSvgIcon-root {
      color: ${lightColorPalette.lbGreyDisabled};
    }

    .MuiAvatar-root {
      background-color: ${lightColorPalette.lbGreyDisabled}!important;

      > p {
        color: ${lightColorPalette.lbBlue_20}!important;
      }
    }
  `}
`;
